export default "__VITE_ASSET__etHFQzFw__"